import { gql } from 'apollo-boost'

export const READ_ALL = gql`
  mutation readNotification($id: Int) {
    response: readNotification (id: $id)
  }
`
